import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';

    interface Props {
        className?: HTMLAttributes['class'];
    }

    
export default /*@__PURE__*/_defineComponent({
  ...{
        inheritAttrs: false,
    },
  __name: 'CorpayOne',
  props: {
    className: {}
  },
  setup(__props: any) {

    

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(_ctx.className)
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.23782 0.542969L10.3794 0.550204L10.7629 1.38344C10.8566 1.62039 10.9611 1.8769 11.0768 2.10227L11.8064 3.77908L16.0748 13.6424C16.0302 13.666 15.3371 13.6426 15.2362 13.6424L12.938 13.64L11.5881 13.6474L8.74744 7.10157L8.13717 5.69494L4.66108 13.6454L0.174805 13.6496L5.88027 0.54817L6.23782 0.542969Z",
      fill: "currentColor"
    }, null, -1)
  ]), 2))
}
}

})